import axios from 'axios';
import queryString from 'query-string';
import { isUndefined } from 'lodash/lang';
import { API_URL } from '../config';
import {
  convertContractToApiFormat,
  convertSuggestionToStoreFormat,
  convertContractToStoreFormat,
} from '../helpers/travel/travelContractHelpers';
import {
  convertPropertyContractToApiFormat,
  convertPropertyContractToStoreFormat,
} from '../helpers/propertyContractHelpers';
import {
  convertCmtplContractToApiFormat,
  convertCmtplContractToStoreFormat,
} from '../helpers/cmtpl/cmtplContractHelpers';
import { uploadFormData } from './uploadApi';
import { OWN_USE_TYPE, POLICY_HOLDER_TYPES } from '../constants/cmtplCalcConstants';

export const fetchPdf = async (type, id) => {
  const URL = `${API_URL}/contract/${type}/${id}`;
  return axios(URL, {
    method: 'GET',
  }).then((response) => response.data);
};

export const fetchContractData = async (type, id) => {
  const URL = `${API_URL}/${type}-contract/${id}`;
  return axios(URL, {
    method: 'GET',
  }).then((response) => response.data);
};

export const createTravelDraft = async (data) => {
  const payload = convertContractToApiFormat(data);
  const URL = `${API_URL}/draft-contract/travel`;
  return axios.post(URL, payload).then((res) => res.data);
};

export const updateTravelDraft = async (data) => {
  const payload = convertContractToApiFormat(data);
  const URL = `${API_URL}/draft-contract/travel/${data.draftId}`;

  return axios.put(URL, payload).then((res) => res.data);
};

const uploadCoverageFiles = (coverageFiles, draftId) => {
  const formData = new FormData();
  if (coverageFiles.length) {
    coverageFiles.forEach((files) => {
      formData.append('coverage_files[]', files.data);
    });
  } else {
    formData.append('coverage_files[]', []);
  }
  formData.append('draftId', draftId);
  const URL = `${API_URL}/upload-coverage-files`;
  uploadFormData(URL, formData);
};

export const saveContractInCache = async (data) => {
  const payload = convertContractToApiFormat(data);
  const URL = `${API_URL}/cache`;
  return axios.post(URL, payload).then((res) => res.data);
};

export const fetchSuggestions = async () => {
  const URL = `${API_URL}/travel-contract/suggestions`;
  return axios.get(URL).then((res) => res.data.map(convertSuggestionToStoreFormat));
};

export async function fetchTravelDraftContractByToken(id, token) {
  const queryParams = { id, token };
  const URL = `${API_URL}/draft-contract/travel?${queryString.stringify(queryParams)}`;
  return axios(URL, {
    method: 'GET',
  }).then((response) => convertContractToStoreFormat(response.data));
}

export const createPropertyDraft = async (data) => {
  const payload = convertPropertyContractToApiFormat(data);
  const URL = `${API_URL}/draft-contract/property`;
  return axios.post(URL, payload).then((res) => res.data);
};

export const updatePropertyDraft = async (data) => {
  const payload = convertPropertyContractToApiFormat(data);
  const URL = `${API_URL}/draft-contract/property/${data.draftId}`;

  return axios.put(URL, payload).then((res) => res.data);
};

export const savePropContractInCache = async (data) => {
  const payload = convertPropertyContractToApiFormat(data);
  const URL = `${API_URL}/cache`;
  return axios.post(URL, payload).then((res) => res.data);
};

export async function fetchPropertyDraftContractByToken(id, token) {
  const queryParams = { id, token };
  const URL = `${API_URL}/draft-contract/property?${queryString.stringify(queryParams)}`;
  return axios(URL, {
    method: 'GET',
  }).then((response) => convertPropertyContractToStoreFormat(response.data));
}

export const createCmtplDraft = async (data) => {
  const payload = convertCmtplContractToApiFormat(data);
  const URL = `${API_URL}/draft-contract/appa`;
  return axios.post(URL, payload).then((res) => res.data);
};

export const updateCmtplDraft = async (data) => {
  const payload = convertCmtplContractToApiFormat(data);
  const URL = `${API_URL}/draft-contract/appa/${data.draftId}`;

  return axios.put(URL, payload).then((res) => res.data);
};

export const saveVehicleContractInCache = async (data) => {
  const payload = convertCmtplContractToApiFormat(data);
  const URL = `${API_URL}/cache`;
  return axios.post(URL, payload).then((res) => {
    if (
      data.draftData.useType.id === OWN_USE_TYPE.id
      && data.draftData.policyHolderType === POLICY_HOLDER_TYPES.INDIVIDUAL
      && !isUndefined(data.cmtplDetails.coverageFiles)
      && data.cmtplDetails.coverageFiles.length
    ) {
      uploadCoverageFiles(data.cmtplDetails.coverageFiles, res.data.id);
    }

    return res.data;
  });
};

export async function fetchCmtplDraftContractByToken(id, token) {
  const queryParams = { id, token };
  const URL = `${API_URL}/draft-contract/appa?${queryString.stringify(queryParams)}`;
  return axios(URL, {
    method: 'GET',
  }).then((response) => convertCmtplContractToStoreFormat(response.data));
}

export const validateContract = async (body) => {
  const URL = `${API_URL}/policy/validation`;
  return axios.post(URL, body).then(({ data }) => data.result);
};

export const fetchMobileContractData = (payload, prefix) => axios.get(`${API_URL}/${prefix}`,
  { params: payload }).then((response) => response.data.data);
